import { render, staticRenderFns } from "./CarouselMarquee.vue?vue&type=template&id=5cc07fcc"
import script from "./CarouselMarquee.vue?vue&type=script&lang=js"
export * from "./CarouselMarquee.vue?vue&type=script&lang=js"
import style0 from "./CarouselMarquee.vue?vue&type=style&index=0&id=5cc07fcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports